"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Provides information about custom tree structure
 * ( eg. tree structure that is made from 4Box, windows and windowItems )
 */


var TreeInfoDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(TreeInfoDTO, _DomainObject_1$Domai);

  /**
   * @param id
   * @param level
   * @param parentId
   * @param childrenIds
   * @param dataType Should be className of entity T ( eg WindowItem.name )
   * @param data
   */
  function TreeInfoDTO(id, level, parentId, childrenIds, dataType, data) {
    var _this;

    _classCallCheck(this, TreeInfoDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeInfoDTO).call(this));
    _this.id = id;
    _this.level = level;
    _this.parentId = parentId;
    _this.childrenIds = childrenIds;
    _this.dataType = dataType;
    _this.data = data;
    return _this;
  }

  return TreeInfoDTO;
}(DomainObject_1.DomainObject);

exports.TreeInfoDTO = TreeInfoDTO;